'use strict';

var React = require('react');
var reactIcons = require('@sravni/react-icons');
var reactUtils = require('@sravni/react-utils');
var Icon = require('../../Icon/src/Icon.js');
var Space = require('../../Space/src/Space.js');
var Arrows_module = require('../styles/Arrows.module.less.js');

function _interopNamespaceDefault(e) {
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n.default = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespaceDefault(React);

/** Inner sub-component for Carousel */
const Arrows = React__namespace.forwardRef((props, ref) => {
    const { isPrevDisabled, isNextDisabled, onPrevClick, onNextClick, ...restProps } = props;
    const cx = reactUtils.useStyles(Arrows_module.default);
    return (React__namespace.createElement(Space.Space, { ref: ref, align: "end", justify: "end", size: 12, className: cx('arrows', 'important'), ...restProps },
        React__namespace.createElement(Icon.Icon, { className: cx('arrow', 'leftArrow', { disabled: isPrevDisabled }), size: 16, shape: "round", onClick: onPrevClick },
            React__namespace.createElement(reactIcons.ArrowLeft, null)),
        React__namespace.createElement(Icon.Icon, { className: cx('arrow', 'rightArrow', { disabled: isNextDisabled }), size: 16, shape: "round", onClick: onNextClick },
            React__namespace.createElement(reactIcons.ArrowRight, null))));
});
Arrows.displayName = 'Arrows';

exports.Arrows = Arrows;
//# sourceMappingURL=Arrows.js.map
